// extracted by mini-css-extract-plugin
export default {"main_card":"Card_main_card__rRaXv","main_card_image":"Card_main_card_image__0iM9L","main_card_img":"Card_main_card_img__iY7rw","episode_number":"Card_episode_number__ALh+L"};